(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54526,7797,5783,56012,75978,91058,99257,33030,49105],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 69726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_AssessmentSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/components/CircularProgress/styles.module.scss
var styles_module = __webpack_require__(91748);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/CircularProgress/index.jsx



var CircularProgress = function(param) {
    var percentage = param.percentage, rangeEnd = param.rangeEnd, displayText = param.displayText, _size = param.size, size = _size === void 0 ? 160 : _size, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 12 : _strokeWidth, _color = param.color, color = _color === void 0 ? "#6366f1" : _color, rangeColor = param.rangeColor, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#e5e7eb" : _bgColor, label = param.label, _animated = param.animated, animated = _animated === void 0 ? true : _animated;
    var ref = (0,react.useState)(0), animatedStart = ref[0], setAnimatedStart = ref[1];
    var ref1 = (0,react.useState)(0), animatedEnd = ref1[0], setAnimatedEnd = ref1[1];
    var clampedStart = Math.min(100, Math.max(0, percentage));
    var clampedEnd = rangeEnd !== undefined ? Math.min(100, Math.max(0, rangeEnd)) : clampedStart;
    var isRange = rangeEnd !== undefined;
    (0,react.useEffect)(function() {
        if (!animated) {
            setAnimatedStart(clampedStart);
            setAnimatedEnd(clampedEnd);
            return;
        }
        if ( true && "requestAnimationFrame" in window) {
            var start = null;
            var duration = 1000;
            var prevStart = animatedStart;
            var prevEnd = animatedEnd;
            var animate = function(timestamp) {
                if (!start) start = timestamp;
                var elapsed = timestamp - start;
                var progress = Math.min(elapsed / duration, 1);
                var eased = 1 - Math.pow(1 - progress, 3);
                setAnimatedStart(prevStart + (clampedStart - prevStart) * eased);
                setAnimatedEnd(prevEnd + (clampedEnd - prevEnd) * eased);
                if (progress < 1) {
                    window.requestAnimationFrame(animate);
                }
            };
            window.requestAnimationFrame(animate);
        }
    }, [
        clampedStart,
        clampedEnd,
        animated,
        animatedStart,
        animatedEnd
    ]);
    var radius = (size - strokeWidth) / 2;
    var circumference = 2 * Math.PI * radius;
    var singleOffset = circumference - animatedStart / 100 * circumference;
    var rangeStartOffset = circumference - animatedStart / 100 * circumference;
    var rangeEndOffset = circumference - animatedEnd / 100 * circumference;
    var getDisplayText = function() {
        if (displayText) return displayText;
        if (isRange) {
            return "".concat(Math.round(animatedStart), "-").concat(Math.round(animatedEnd), "%");
        }
        return "".concat(Math.round(animatedStart), "%");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).progressWrapper,
            style: {
                width: size,
                height: size
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: size,
                    height: size,
                    className: (styles_module_default()).svg,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: size / 2,
                            cy: size / 2,
                            r: radius,
                            fill: "none",
                            stroke: bgColor,
                            strokeWidth: strokeWidth
                        }),
                        isRange ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: size / 2,
                                    cy: size / 2,
                                    r: radius,
                                    fill: "none",
                                    stroke: rangeColor || color,
                                    strokeWidth: strokeWidth,
                                    strokeDasharray: circumference,
                                    strokeDashoffset: rangeEndOffset,
                                    strokeLinecap: "round",
                                    opacity: 0.3
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: size / 2,
                                    cy: size / 2,
                                    r: radius,
                                    fill: "none",
                                    stroke: color,
                                    strokeWidth: strokeWidth,
                                    strokeDasharray: circumference,
                                    strokeDashoffset: rangeStartOffset,
                                    strokeLinecap: "round"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: size / 2,
                            cy: size / 2,
                            r: radius,
                            fill: "none",
                            stroke: color,
                            strokeWidth: strokeWidth,
                            strokeDasharray: circumference,
                            strokeDashoffset: singleOffset,
                            strokeLinecap: "round"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).title,
                            style: {
                                fontSize: size * 0.15,
                                lineHeight: 1.2
                            },
                            children: getDisplayText()
                        }),
                        label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).subtitle,
                            style: {
                                fontSize: size * 0.09,
                                marginTop: 2
                            },
                            children: label
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CircularProgress = (CircularProgress);

// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./UI/sections/AssessmentSection/utils/useAssessmentSection.js






var getMostChosenLetter = function(answersMap) {
    var letters = Object.values(answersMap);
    if (!letters.length) {
        return null;
    }
    var counts = letters.reduce(function(acc, letter) {
        acc[letter] = (acc[letter] || 0) + 1;
        return acc;
    }, {});
    return Object.entries(counts).sort(function(a, b) {
        return b[1] - a[1];
    })[0][0];
};
var useAssessmentSection = function(param) {
    var section = param.section, type = param.type, handleOnCTAClick = param.handleOnCTAClick;
    var ref = (0,helper/* getDocumentFields */.OA)(section, [
        "title",
        "contentModules",
        "description"
    ]), title = ref.title, contentModules = ref.contentModules, description = ref.description;
    var questionsModule = contentModules === null || contentModules === void 0 ? void 0 : contentModules[0];
    var resultsModule = contentModules === null || contentModules === void 0 ? void 0 : contentModules[1];
    var ref1 = (0,helper/* getDocumentFields */.OA)(questionsModule, [
        "contentModules"
    ]), questionModules = ref1.contentModules;
    var questions = (questionModules || []).map(function(question) {
        var ref = (0,helper/* getDocumentFields */.OA)(question, [
            "title",
            "contentModules"
        ]), questionTitle = ref.title, answerModules = ref.contentModules;
        var answers = (answerModules || []).map(function(answer) {
            var ref = (0,helper/* getDocumentFields */.OA)(answer, [
                "title",
                "subtitle"
            ]), answerTitle = ref.title, subtitle = ref.subtitle;
            return {
                title: answerTitle,
                letter: subtitle
            };
        });
        return {
            title: questionTitle,
            answers: answers
        };
    });
    var ref2 = (0,helper/* getDocumentFields */.OA)(resultsModule, [
        "contentModules"
    ]), resultModules = ref2.contentModules;
    var results = (resultModules || []).map(function(result) {
        var ref = (0,helper/* getDocumentFields */.OA)(result, [
            "title",
            "subtitle",
            "text",
            "contentModules",
            "description"
        ]), resultTitle = ref.title, subtitle = ref.subtitle, resultDescription = ref.description, text = ref.text, suggestionData = ref.contentModules;
        var ref1 = (0,helper/* getDocumentFields */.OA)(suggestionData[0], [
            "contentModules"
        ]), suggestionsList = ref1.contentModules;
        var linkData = (0,helper/* getDocumentFields */.OA)(suggestionData[1], [
            "buttonTitle",
            "url",
            "slug"
        ]);
        var percentage = {};
        if (resultDescription) {
            var ref2 = (0,_sliced_to_array/* default */.Z)(resultDescription.split("-"), 2), startRange = ref2[0], endRange = ref2[1];
            percentage = {
                startRange: +startRange || 0,
                endRange: +endRange || 0
            };
        }
        return (0,_object_spread/* default */.Z)({
            title: resultTitle,
            letter: subtitle,
            text: text,
            suggestions: suggestionsList,
            link: linkData
        }, percentage);
    });
    var ref3 = (0,react.useState)(0), currentIndex = ref3[0], setCurrentIndex = ref3[1];
    var ref4 = (0,react.useState)({}), answersMap = ref4[0], setAnswersMap = ref4[1];
    var ref5 = (0,react.useState)(null), selectedLetter = ref5[0], setSelectedLetter = ref5[1];
    var ref6 = (0,react.useState)(null), result = ref6[0], setResult = ref6[1];
    var totalQuestions = questions.length;
    var answeredCount = Object.keys(answersMap).length + 1;
    var currentQuestion = questions[currentIndex];
    var progress = totalQuestions ? answeredCount / totalQuestions * 100 + 1 : 1;
    var isCompleted = Boolean(result);
    var resolveResult = function(finalAnswersMap) {
        var mostChosenLetter = getMostChosenLetter(finalAnswersMap);
        if (!mostChosenLetter) {
            return results[0] || null;
        }
        return results.find(function(param) {
            var letter = param.letter;
            return letter === mostChosenLetter;
        }) || results[0] || null;
    };
    var handleSelectAnswer = function(letter) {
        setSelectedLetter(letter);
    };
    var handleNext = function() {
        if (!selectedLetter) {
            return;
        }
        var nextAnswersMap = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, answersMap), (0,_define_property/* default */.Z)({}, currentIndex, selectedLetter));
        setAnswersMap(nextAnswersMap);
        if (currentIndex >= totalQuestions - 1) {
            setResult(resolveResult(nextAnswersMap));
            return;
        }
        var nextIndex = currentIndex + 1;
        setCurrentIndex(nextIndex);
        setSelectedLetter(nextAnswersMap[nextIndex] || null);
    };
    var handleSkip = function() {
        var nextAnswersMap = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, answersMap), (0,_define_property/* default */.Z)({}, currentIndex, "-"));
        // const nextAnswersMap = {...answersMap};
        // delete nextAnswersMap[currentIndex];
        setAnswersMap(nextAnswersMap);
        if (currentIndex >= totalQuestions - 1) {
            setResult(resolveResult(nextAnswersMap));
            return;
        }
        var nextIndex = currentIndex + 1;
        setCurrentIndex(nextIndex);
        setSelectedLetter(nextAnswersMap[nextIndex] || null);
    };
    var withPercentage = [
        "ai-engineering-transformation/assessment"
    ].includes(type);
    return {
        type: type,
        title: title,
        description: description,
        contentModules: contentModules,
        questions: questions,
        currentQuestion: currentQuestion,
        currentIndex: currentIndex,
        totalQuestions: totalQuestions,
        answeredCount: answeredCount,
        progress: progress,
        selectedLetter: selectedLetter,
        isCompleted: isCompleted,
        result: result,
        handleSelectAnswer: handleSelectAnswer,
        handleNext: handleNext,
        handleSkip: handleSkip,
        handleOnCTAClick: handleOnCTAClick,
        withPercentage: withPercentage
    };
};

;// CONCATENATED MODULE: ./UI/sections/AssessmentSection/utils/assessmentSectionHelper.js
var getRecentageTitle = function(startRange, endRange) {
    if (startRange && endRange === 100) {
        return "".concat(startRange, "% and more");
    }
    if (startRange && endRange) {
        return "".concat(startRange, "-").concat(endRange, "%");
    }
    return "".concat(startRange, "%");
};

// EXTERNAL MODULE: ./UI/sections/AssessmentSection/styles.module.scss
var AssessmentSection_styles_module = __webpack_require__(86536);
var AssessmentSection_styles_module_default = /*#__PURE__*/__webpack_require__.n(AssessmentSection_styles_module);
;// CONCATENATED MODULE: ./UI/sections/AssessmentSection/index.jsx
















var AssessmentSection = function(props) {
    var ref, ref1;
    var ref2 = useAssessmentSection(props), type = ref2.type, title = ref2.title, description = ref2.description, contentModules = ref2.contentModules, currentQuestion = ref2.currentQuestion, totalQuestions = ref2.totalQuestions, answeredCount = ref2.answeredCount, progress = ref2.progress, selectedLetter = ref2.selectedLetter, isCompleted = ref2.isCompleted, result = ref2.result, handleSelectAnswer = ref2.handleSelectAnswer, handleNext = ref2.handleNext, handleSkip = ref2.handleSkip, handleOnCTAClick = ref2.handleOnCTAClick, withPercentage = ref2.withPercentage;
    if (!contentModules || !totalQuestions) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((AssessmentSection_styles_module_default())[type], (AssessmentSection_styles_module_default()).container),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((AssessmentSection_styles_module_default()).wrapper, (0,_define_property/* default */.Z)({}, (AssessmentSection_styles_module_default()).result, isCompleted && result)),
            children: [
                !(isCompleted && result) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    description: description,
                    className: (AssessmentSection_styles_module_default()).title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AssessmentSection_styles_module_default()).badge,
                    children: "YOUR RESULT"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (AssessmentSection_styles_module_default()).card,
                    children: [
                        !isCompleted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AssessmentSection_styles_module_default()).progressBlock,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (AssessmentSection_styles_module_default()).progressHeader,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography["default"], {
                                                size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh14 */.y3.paragrapgh14,
                                                className: (AssessmentSection_styles_module_default()).progressCounter,
                                                children: [
                                                    answeredCount,
                                                    "/",
                                                    totalQuestions
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (AssessmentSection_styles_module_default()).progressBar,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (AssessmentSection_styles_module_default()).progressFill,
                                                style: {
                                                    width: "".concat(progress, "%")
                                                }
                                            })
                                        })
                                    ]
                                }),
                                currentQuestion && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AssessmentSection_styles_module_default()).questionBlock,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                            isBold: true,
                                            size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                                            mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                                            className: (AssessmentSection_styles_module_default()).questionTitle,
                                            children: currentQuestion.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (AssessmentSection_styles_module_default()).answers,
                                            role: "radiogroup",
                                            "aria-label": currentQuestion.title,
                                            children: currentQuestion.answers.map(function(param) {
                                                var answerTitle = param.title, letter = param.letter;
                                                var inputId = "assessment-answer-".concat(letter, "-").concat(answerTitle);
                                                var isChecked = selectedLetter === letter;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    htmlFor: inputId,
                                                    className: classnames_default()((AssessmentSection_styles_module_default()).answer, (0,_define_property/* default */.Z)({}, (AssessmentSection_styles_module_default()).checked, isChecked)),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: inputId,
                                                            type: "radio",
                                                            name: "assessment-answer",
                                                            value: letter,
                                                            checked: isChecked,
                                                            onChange: function() {
                                                                return handleSelectAnswer(letter);
                                                            },
                                                            className: (AssessmentSection_styles_module_default()).radioInput
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (AssessmentSection_styles_module_default()).radioMark
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                            size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                                                            className: (AssessmentSection_styles_module_default()).answerTitle,
                                                            children: answerTitle
                                                        })
                                                    ]
                                                }, "".concat(letter, "-").concat(answerTitle));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AssessmentSection_styles_module_default()).actions,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            secondary: true,
                                            onClick: handleSkip,
                                            className: (AssessmentSection_styles_module_default()).skipButton,
                                            children: "Skip for now"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            onClick: handleNext,
                                            disabled: !selectedLetter,
                                            className: (AssessmentSection_styles_module_default()).nextButton,
                                            children: "Next"
                                        })
                                    ]
                                })
                            ]
                        }),
                        isCompleted && result && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AssessmentSection_styles_module_default()).resultBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AssessmentSection_styles_module_default()).topContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((0,_define_property/* default */.Z)({}, (AssessmentSection_styles_module_default()).resultContent, withPercentage)),
                                            children: [
                                                result.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                    isBold: true,
                                                    size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                                                    mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                                                    className: (AssessmentSection_styles_module_default()).resultTitle,
                                                    children: result.title
                                                }),
                                                result.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (AssessmentSection_styles_module_default()).resultText,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                                        document: result.text
                                                    })
                                                })
                                            ]
                                        }),
                                        withPercentage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CircularProgress, {
                                            percentage: result.startRange,
                                            rangeEnd: result.endRange,
                                            displayText: getRecentageTitle(result.startRange, result.endRange),
                                            label: "capacity lost",
                                            color: "#ffe603",
                                            rangeColor: "#ffe603",
                                            bgColor: "#fafafa",
                                            textColor: "#171717",
                                            size: 140,
                                            strokeWidth: 10
                                        })
                                    ]
                                }),
                                !!(result === null || result === void 0 ? void 0 : (ref = result.suggestions) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AssessmentSection_styles_module_default()).suggestionList,
                                    children: result.suggestions.map(function(item) {
                                        var ref = (0,helper/* getDocumentFields */.OA)(item, [
                                            "title",
                                            "description",
                                            "contentList"
                                        ]), resultTitle = ref.title, resultDescription = ref.description, contentList = ref.contentList;
                                        var icon = get_default()(contentList, "[0]");
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (AssessmentSection_styles_module_default()).suggestionContainer,
                                            children: [
                                                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (AssessmentSection_styles_module_default()).iconWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                                        type: icon,
                                                        className: (AssessmentSection_styles_module_default()).icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (AssessmentSection_styles_module_default()).suggestionTitle,
                                                            children: resultTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (AssessmentSection_styles_module_default()).suggestionDescription,
                                                            children: resultDescription
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    })
                                }),
                                (result === null || result === void 0 ? void 0 : (ref1 = result.link) === null || ref1 === void 0 ? void 0 : ref1.buttonTitle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button["default"], {
                                    onClick: !result.link.url && handleOnCTAClick,
                                    className: (AssessmentSection_styles_module_default()).ctaButton,
                                    href: result.link.url || result.link.slug,
                                    "data-button": true,
                                    children: [
                                        result.link.buttonTitle,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                            type: "arrowRight"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
AssessmentSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_AssessmentSection = (AssessmentSection);


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 91748:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__7i9_4","progressWrapper":"styles_progressWrapper__c3ZHs","svg":"styles_svg__GD1dv","content":"styles_content__NUW6m","title":"styles_title__stO7x","subtitle":"styles_subtitle__dSGI4"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 86536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__Q_zWy","cards":"styles_cards__rTmPx","imageWrapper":"styles_imageWrapper__RjwSQ","typeTitle":"styles_typeTitle__U8Cqk","greySection":"styles_greySection__b3Ub9","callToAction":"styles_callToAction__XNuY2","threeColumnsCards":"styles_threeColumnsCards__z_cIZ","twoColumnsCards":"styles_twoColumnsCards__0ST4c","textContent":"styles_textContent__ax77x","container":"styles_container___R2SL","wrapper":"styles_wrapper__sJib3","result":"styles_result__yOiJc","title":"styles_title__BBC_C","topContent":"styles_topContent__d5OxM","resultContent":"styles_resultContent__Mz6Sv","progressBlock":"styles_progressBlock__Zm_8J","progressHeader":"styles_progressHeader__ubf0q","progressLabel":"styles_progressLabel__l5Q1X","progressCounter":"styles_progressCounter__rDc9C","progressBar":"styles_progressBar__Kbiyv","progressFill":"styles_progressFill__veQd1","questionBlock":"styles_questionBlock__xHg3c","questionTitle":"styles_questionTitle__L4wy5","answers":"styles_answers__cB_KC","answer":"styles_answer__N_5ub","checked":"styles_checked__f0Xx9","radioInput":"styles_radioInput__jgQ76","radioMark":"styles_radioMark__Yq03r","answerTitle":"styles_answerTitle__Y2ps2","actions":"styles_actions__M8puh","skipButton":"styles_skipButton___rebN","nextButton":"styles_nextButton__qjqL9","resultBlock":"styles_resultBlock__O5n3h","resultTitle":"styles_resultTitle__cPuCU","resultText":"styles_resultText__6f_zT","badge":"styles_badge__Slfyk","suggestionList":"styles_suggestionList__Z9er2","suggestionContainer":"styles_suggestionContainer__5L1M3","suggestionTitle":"styles_suggestionTitle__V8nkV","iconWrapper":"styles_iconWrapper__iJcG9","ctaButton":"styles_ctaButton__N776J"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);